import type {TaskStatus} from "@book-video-studio/contracts";

export const statusText: Record<TaskStatus, string> = {
  draft: "草稿",
  uploading: "上传素材",
  queued: "等待本地电脑",
  claimed: "已被领取",
  processing: "制作中",
  uploading_result: "回传成片",
  completed: "已完成",
  failed: "失败",
  cancelled: "已取消"
};

export const isActiveStatus = (status: TaskStatus): boolean =>
  ["queued", "claimed", "processing", "uploading_result"].includes(status);

const phaseLabels: Record<string, string> = {
  uploading: "等待素材上传",
  queued: "等待本地电脑领取",
  claimed: "本地电脑已领取",
  downloading: "正在下载素材",
  extracting_audio: "正在提取并处理旁白音频",
  transcribing: "正在识别字幕",
  reviewing_transcript: "正在核对字幕并设计分页",
  timeline: "正在计算图片切换点",
  rendering: "正在生成视频",
  uploading_result: "正在回传成片",
  completed: "视频制作完成",
  failed: "制作失败",
  cancelled: "任务已取消"
};

export const phaseText = (phase: string | null): string => phase ? (phaseLabels[phase] ?? phase) : "等待更新";
